package game

import com.soywiz.korim.bitmap.Bitmap
import com.soywiz.korim.bitmap.BmpSlice
import com.soywiz.korim.bitmap.sliceWithSize

var CGA_GLYPH_WIDTH = 8
var CGA_GLYPH_HEIGHT = 8
var CGA_GLYPH_COUNT = 256

class CgaGlyph(val name: String, val glyph: BmpSlice) {

}

class CgaFont(val bitmap: Bitmap) {
    private val glyphs: Array<CgaGlyph> = Array(CGA_GLYPH_COUNT) {
        CgaGlyph(
            it.toString(), bitmap.sliceWithSize(
                it * (CGA_GLYPH_WIDTH),
                0,
                CGA_GLYPH_WIDTH,
                CGA_GLYPH_HEIGHT,
                it.toString()
            )
        )
    }

    operator fun get(char: Int) = glyphs[char]
    val charHeight = CGA_GLYPH_HEIGHT
    val charWidth = CGA_GLYPH_WIDTH
}
